import { PaintBrushIcon } from '@heroicons/react/24/solid';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

import { satisfiesCCLI } from '../functions';
import { AnnotatedResource } from '../types';
import { ReactNode } from 'react';

type Props = {
  resource: AnnotatedResource | null
}

export const ResourceStatusIcons = ({ resource }: Props) => {

  const children: ReactNode[] = [];

  if (resource?.annotations?.themeID) {
    children.push(
      <PaintBrushIcon
        className='size-6 text-gray-400'
        title='Has a specific theme set in this playlist'
      />
    );
  }

  if (resource && !satisfiesCCLI(resource)) {
    children.push(
      <ExclamationTriangleIcon
        className='size-6 text-yellow-500'
        title='Author and copyright should be specified for CCLI-licensed songs'
      />
    );
  }

  return (
    <>{ children }</>
  );
};
